import { Box, Divider, ListItemButton, Typography, listItemButtonClasses } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const SelectorRoot = styled(Box)({
  height: '100%',
  minHeight: 0,
});

/** The loading and "no series" notes in place of the list. */
export const SelectorMessage = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const SeriesGroupItem = styled('li')({
  listStyle: 'none',
});

export const SeriesGroupDivider = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(1, 2),
}));

export const SeriesListItemButton = styled(ListItemButton)(({ theme }) => ({
  gap: theme.spacing(1.5),
  minHeight: theme.spacing(5),
  padding: theme.spacing(0.75, 2),

  [`&.${listItemButtonClasses.selected}`]: {
    backgroundColor: alpha(theme.palette.secondary.main, theme.palette.action.selectedOpacity),
    color: theme.palette.secondary.main,

    '&:hover': {
      backgroundColor: alpha(theme.palette.secondary.main, theme.palette.action.selectedOpacity),
    },
  },
}));
